import React from 'react';
import { getIn, useFormikContext } from 'formik';
import { OrderSelect } from './OrderSelect';
import { ISelectProps } from 'ui-toolkit';
import { IOrderOption } from 'types/accounting/IOrderOption';

export interface IOrderSelectFieldProps extends ISelectProps {
  onOptionSet: (option?: IOrderOption) => void;
  name: string;
}

export const OrderSelectField: React.FC<IOrderSelectFieldProps> = ({ name, ...rest }) => {
  const formik = useFormikContext();
  const onChange = async (value: any) => {
    await formik.setFieldTouched(name);
    await formik.setFieldValue(name, value);
  };
  const errorText =
    (!!formik.submitCount || !!getIn(formik.touched, name)) && !!getIn(formik.errors, name)
      ? getIn(formik.errors, name)
      : null;
  const value = getIn(formik.values, name);
  return <OrderSelect name={name} {...rest} onChange={onChange} errorText={errorText} value={value} />;
};
